import { createTheme } from '@eduact/student-theme'

/**
 * AbwaabPlus design-system theme — the product default.
 *
 * This maps the AbwaabPlus brand palette onto the existing `@eduact/student-theme`
 * color keys so that legacy `@eduact` components (rendered on not-yet-migrated pages)
 * pick up the new brand without any code changes. The new portal-native primitives
 * under `src/Components/AbwaabPlus/*` read the CSS-variable token layer emitted by
 * GlobalStyles, which derives its brand vars from `theme.colors.primary` etc.
 *
 * Brand reference (abwaabplus-design-system/project/tokens/colors.css):
 *   blue #0655CB · blue-hover #0044AE · navy #002F77 · yellow #FFCA00
 *   success #22C55E · error #EF4444 · warning #F59E0B
 *   border #E5E7EB · text-primary #1F2937 · text-secondary #6B7280
 *   surface-sunken #F9FAFB · surface-sunken-strong #F3F4F6 · scrollbar-thumb #D1D5DB
 *
 * Structural tokens (borderRadii, spacing, media queries) are intentionally left at
 * package defaults so legacy component proportions are unchanged.
 */
export const abwaabPlusTheme = createTheme({
	colors: {
		// ── Brand blue (primary actions, links, active, progress fills) ──
		primary: '#0655CB',

		// ── Brand yellow (highlights, offers, featured) ──
		yellow: '#FFCA00',

		// ── Functional UI signals ──
		green: '#22C55E', // success
		red: '#EF4444', // error
		lightRed: '#EF4444',
		orange: '#F59E0B', // warning
		princetonOrange: '#F59E0B',

		// ── Blue-family accents remapped from the legacy purple ramp so older
		//    components that used purple now read on-brand blue/navy ──
		purple: '#0655CB',
		maxBluePurple: '#3B82F6',
		purpleNavy: '#002F77',
		independence: '#1F2937', // deep text / dark accent
		lavender: '#E8F0FE', // light blue tint surface

		// ── Neutrals & surfaces ──
		light: '#FFFFFF',
		cultured: '#F9FAFB', // surface-sunken (gray-50)
		darkCultured: '#F3F4F6', // surface-sunken-strong (gray-100)
		platinum: '#E5E7EB', // border
		// `silver`/`spanishGray` are overloaded by legacy code as mid-gray *text/icon*
		// colors (inactive tabs, input helper text, placeholders). Keep them readable
		// neutrals — NOT near-white — or those elements disappear on white surfaces.
		silver: '#9CA3AF', // neutral — inactive text/icons, disabled, scrollbar track
		spanishGray: '#6B7280', // secondary text / icons
		darkSilver: '#6B7280', // secondary text
	},
})
